import { ToggleButtonGroup } from "@mui/material";
import React from "react";
import AddIcon from "../../assets/icons/Add_icon.svg";
import VisaImage from "../../assets/images/visa_logo.svg";
import { StyledToggleButton } from "../../molecules/ToggleButton";
const cards = [
  {
    cardImage: VisaImage,
    cardNumber: "1232 2311 3423 342",
    exp: "09-24",
  },
  {
    cardImage: VisaImage,
    cardNumber: "1232 9911 3423 342",
    exp: "09-24",
  },
];

const PaymentToggleCards = () => {
  const [selected, setSelected] = React.useState({});
  const handleValue = (e, value) => {
    if (value !== null) {
      setSelected(value);
    }
  };

  return (
    <div className="overflow-x-scroll md:overflow-x-auto p-4 md:p-4 mx-4 md:mx-0">
      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleValue}
        aria-label="text alignment"
      >
        {cards.map((card) => (
          <StyledToggleButton
            value={card}
            className="w-[200px] md:w-[300px]"
            key={card.cardNumber}
          >
            <div className="mb-2 text-xl text-dark font-bold">
              <img
                src={card.cardImage}
                alt={"PCB play"}
                className="h-10 md:h-auto"
              />
            </div>
            <div className="text-dark/70 text-sm md:text-base">
              **** **** ***{card.cardNumber.slice(12)}
            </div>
            <div className="text-dark/70 text-sm md:text-base">
              expires {card.exp}
            </div>
          </StyledToggleButton>
        ))}

        {/* ADD MORE */}
        {/* ADD MORE */}
        <div className="cursor-pointer p-5 md:p-10 rounded-xl bg-grey/10 flex flex-col item-center justify-center">
          <img
            src={AddIcon}
            alt={"PCB play"}
            className="h-[25px] md:h-[35px]"
          />
          <p className="text-center text-dark/80 my-2 text-sm whitespace-nowrap	">
            add address
          </p>
        </div>
      </ToggleButtonGroup>
    </div>
  );
};

export default PaymentToggleCards;
